import { ERROR_401 } from 'common/config/api';

const throwError = (message: string, error?: unknown) => {
  if (error instanceof Error
    && typeof error === 'object'
    && 'status' in error
    && error.status === Number(ERROR_401)
  ) {
    return null;
  }
  throw new Error(message);
};

export default throwError;
